/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Button } from '@/styles/HDM/Button';
import { Checkbox } from '@/styles/HDM/Checkbox';
import { CssBaseline } from '@/styles/HDM/CssBaseline';
import { Icon } from '@/styles/HDM/Icon';
import { Link } from '@/styles/HDM/Link';
import { Radio } from '@/styles/HDM/Radio';
import { TextField } from '@/styles/HDM/TextField';
import { Typography } from '@/styles/HDM/Typography';
import { breakpoints } from '@/styles/HDM/breakpoints';
import { contrastText } from '@/styles/HDM/contrastText';
import { customSpacing } from '@/styles/HDM/customSpacing';
import { dimensions } from '@/styles/HDM/dimensions';
import { elevationShadows } from '@/styles/HDM/elevationShadows';
import { fonts } from '@/styles/HDM/fonts';
import { palette } from '@/styles/HDM/palette';
import { shape } from '@/styles/HDM/shape';
import { typography } from '@/styles/HDM/type';
import { ThemeManifestTheme } from '@/styles/manifest';

export const HDMTheme: ThemeManifestTheme = {
	inheritFrom: 'Default',
	components: [
		dimensions,
		palette,
		typography,
		breakpoints,
		contrastText,
		CssBaseline,
		fonts,
		shape,
		elevationShadows,
		customSpacing,
		TextField,
		Button,
		Checkbox,
		Icon,
		Radio,
		Typography,
		Link,
	],
};
